import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

const CookieConsentBanner = () => {
  const { t } = useTranslation()
  const [accepted, setAccepted] = useState(false)

  useEffect(() => {
    const userAccepted = localStorage.getItem('cookieConsentAccepted')
    if (userAccepted) {
      setAccepted(true)
    }
  }, [])

  const handleAccept = () => {
    setAccepted(true)
    localStorage.setItem('cookieConsentAccepted', true)
  }

  if (accepted) {
    return null
  }

  return (
    <div className="cookie-consent-banner">
      <p>{t('COOKIE_CONSENT_MESSAGE')}</p>
      <button className="btn btn-primary" onClick={handleAccept}>
        {t('I_CONSENT')}
      </button>
      {/*<a href="/politique-de-confidentialite">Politique de confidentialité</a>*/}
    </div>
  )
}

export default CookieConsentBanner
